module.exports = __webpack_public_path__ + "img/tonghua1.e14dd524.png";